import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=38d6ccbd&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=ts"
export * from "./DeliveryDetails.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryDetails.scss?vue&type=style&index=0&id=38d6ccbd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6ccbd",
  null
  
)

export default component.exports